export var StorageScope;
(function (StorageScope) {
    StorageScope[StorageScope["USER"] = 1] = "USER";
    StorageScope[StorageScope["DEVICE"] = 2] = "DEVICE";
})(StorageScope || (StorageScope = {}));
